import { createSlice } from '@reduxjs/toolkit';
import settingAccountApi from 'api/settingAccountApi';

const initialState = {
  settingAccount: {},
  metaData: {},
};

const settingAccountSlice = createSlice({
  name: 'settingAccount',
  initialState,
  reducers: {
    setSettingAccount: (state, action) => {
      state.settingAccount = action.payload;
    },
    settingMetaData: (state, action) => {
      state.metaData = action.payload;
    },
  },
});

export const { setSettingAccount, settingMetaData } =
  settingAccountSlice.actions;

export const getSettingAccountAsync =
  (target = 'BASIC_SETTING') =>
  async (dispatch) => {
    const settingAccount = await settingAccountApi.get(target);
    const update = {};
    settingAccount.forEach((item) => {
      update[item.key] = item.value;
    });
    return dispatch(setSettingAccount(update));
  };

export const getMetaDataAsync = () => async (dispatch) => {
  const settingAccount = await settingAccountApi.getMetadata();
  const update = {};
  settingAccount.forEach((item) => {
    update[item.key] = item.value;
  });
  return dispatch(settingMetaData(update));
};


export const getMetaData = (state) => state.settingAccount.metaData;
export default settingAccountSlice.reducer;
